/* video-modal.js — extracted from index.html */
(function(){
  var overlay = document.getElementById('videoOverlay');
  var frame = document.getElementById('videoFrame');
  var caption = document.getElementById('videoCaption');
  if(!overlay || !frame) return;

  function buildPlayer(card){
    var type = card.getAttribute('data-video-type') || 'youtube';
    var id = card.getAttribute('data-video-id') || '';
    var src = card.getAttribute('data-video-src') || '';
    frame.innerHTML = '';

    if(type === 'youtube' && id){
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/'+ id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.setAttribute('title','Client video testimonial');
      iframe.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen','');
      iframe.setAttribute('loading','lazy');
      frame.appendChild(iframe);
    } else if(type === 'vimeo' && id){
      var ifr = document.createElement('iframe');
      ifr.src = 'https://player.vimeo.com/video/'+ id + '?autoplay=1&title=0&byline=0&portrait=0';
      ifr.setAttribute('allow','autoplay; fullscreen; picture-in-picture');
      ifr.setAttribute('allowfullscreen','');
      frame.appendChild(ifr);
    } else if(type === 'mp4' && src){
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.preload = 'metadata';
      frame.appendChild(v);
    } else {
      frame.innerHTML = '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;text-align:center;padding:24px;font-family:inherit;"><div><div style="font-size:32px;margin-bottom:8px;">&#9654;</div><div style="font-size:14px;opacity:.75;">Video URL not configured for this testimonial yet.</div></div></div>';
    }

    var who = card.querySelector('h4') ? card.querySelector('h4').textContent : '';
    var sub = card.querySelector('.vsub') ? card.querySelector('.vsub').textContent : '';
    caption.textContent = (who + (sub ? ', ' + sub : '')).trim();
  }

  function openVideo(card){
    buildPlayer(card);
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    document.body.classList.add('video-locked');
  }
  function closeVideo(){
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','true');
    document.body.classList.remove('video-locked');
    setTimeout(function(){ frame.innerHTML = ''; caption.textContent = ''; }, 260);
  }

  document.addEventListener('click', function(e){
    var card = e.target.closest('.rs-video');
    if(card){ e.preventDefault(); openVideo(card); return; }
    if(e.target === overlay || e.target.matches('[data-video-close]')) closeVideo();
  });
  document.querySelectorAll('.rs-video').forEach(function(card){
    card.setAttribute('tabindex','0');
    card.setAttribute('role','button');
    card.setAttribute('aria-label','Play video testimonial');
    card.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openVideo(card); }
    });
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('is-open')) closeVideo();
  });
})();
